export function getUserAgentInfo() {
  let ua = window.navigator.userAgent;
  const isMobile = !!ua.match(/(iPhone|iPod|Android|ios)/i);
  return {
    isMobile: isMobile,
    isWeChat: !!ua.match(/MicroMessenger.+?([\d.]+)/i),
    clientType: isMobile ? "wap" : "pc"
  };
}

export function bytesToSize(bytes) {
  var sizes = ["B", "KB", "MB", "GB", "TB"];
  if (bytes == 0) return "0 B";
  var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
  return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
}

export function timestampToDateStr(stamp) {
  return new Date(stamp).toISOString().slice(0, 10);
}

export function kickUrlParam(url, param) {
  var urlArr = url.split("?");
  if (urlArr.length === 2) {
    var queryArr = urlArr[1].split("&");
    let i = queryArr.findIndex(q => q.indexOf(param) !== -1);
    if (i !== -1) queryArr.splice(i, 1);
    urlArr[1] = queryArr.join("&");
    return urlArr.join("?");
  }
  return url;
}

export function kickUrlParams(url, params) {
  var urlArr = url.split("?");
  if (urlArr.length === 2) {
    var queryArr = urlArr[1].split("&");
    params.forEach(param => {
      let i = queryArr.findIndex(q => q.indexOf(param) !== -1);
      if (i !== -1) queryArr.splice(i, 1);
    });
    urlArr[1] = queryArr.join("&");
    return urlArr.join("?");
  }
  return url;
}

export function copyToClipboard(text) {
  let t = document.createElement("textarea");
  t.style.position = "fixed";
  t.style.top = "-1000px";
  t.style.left = "-1000px";
  t.value = text;
  document.body.appendChild(t);
  t.focus();
  t.select();
  try {
    document.execCommand("copy");
  } catch (err) {
    console.log("Copy to clipboard failed.");
    return false;
  }
  document.body.removeChild(t);
  return text;
}

export function validateEmail(email) {
  let reg = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
  return email.match(reg);
}
